import { Array } from "@siteimprove/alfa-array";
import { Iterable } from "@siteimprove/alfa-iterable";
import { None, Option } from "@siteimprove/alfa-option";
import { String } from "@siteimprove/alfa-string";
import { Trampoline } from "@siteimprove/alfa-trampoline";
import * as json from "@siteimprove/alfa-json";
import { Node } from "../node.js";
import { Sheet } from "../style/sheet.js";
import { Element } from "./element.js";
/**
 * @public
 */
export class Document extends Node {
    static of(children, style = [], externalId, internalId, extraData) {
        return new Document(Array.from(children), style, externalId, internalId, extraData);
    }
    static empty() {
        return new Document([], []);
    }
    _style;
    _frame = None;
    constructor(children, style, externalId, internalId, extraData) {
        super(children, "document", externalId, internalId, extraData);
        this._style = Array.from(style);
    }
    get style() {
        return this._style;
    }
    get frame() {
        return this._frame;
    }
    parent(options = Node.Traversal.empty) {
        return options.isSet(Node.Traversal.nested)
            ? this.frame
            : super.parent(options);
    }
    /**
     * @internal
     **/
    _internalPath(options = Node.Traversal.empty) {
        if (options.isSet(Node.Traversal.nested)) {
            return this._frame
                .map((frame) => frame.path(options) + "/document-node()")
                .getOr("/");
        }
        return "/";
    }
    toJSON(options) {
        const result = {
            ...super.toJSON(options),
        };
        const verbosity = options?.verbosity ?? json.Serializable.Verbosity.Medium;
        if (verbosity < json.Serializable.Verbosity.Medium) {
            return result;
        }
        result.style = this._style.map((sheet) => sheet.toJSON());
        return result;
    }
    toString() {
        const children = this._children
            .map((child) => String.indent(child.toString()))
            .join("\n");
        return `#document${children === "" ? "" : `\n${children}`}`;
    }
    /**
     * @internal
     */
    _attachParent() {
        return false;
    }
    /**
     * @internal
     */
    _attachFrame(frame) {
        if (this._frozen || this._frame.isSome()) {
            return false;
        }
        this._frame = Option.of(frame);
        this._frozen = true;
        return true;
    }
}
/**
 * @public
 */
(function (Document) {
    function isDocument(value) {
        return value instanceof Document;
    }
    Document.isDocument = isDocument;
    /**
     * @internal
     */
    function fromDocument(json, device) {
        return Trampoline.traverse(json.children ?? [], (child) => Node.fromNode(child, device)).map((children) => Document.of(children, json.style.map(Sheet.from), json.externalId, json.internalId));
    }
    Document.fromDocument = fromDocument;
    /**
     * @internal
     */
    function cloneDocument(options, device) {
        return (document) => Trampoline.traverse(document.children(), (child) => {
            if (Element.isElement(child) && options.predicate(child)) {
                return Trampoline.done(Array.from(options.newElements));
            }
            return Node.cloneNode(child, options, device).map((node) => [node]);
        }).map((children) => {
            return Document.of(Iterable.flatten(children), document.style, document.externalId, document.internalId, document.extraData);
        });
    }
    Document.cloneDocument = cloneDocument;
})(Document || (Document = {}));
//# sourceMappingURL=document.js.map